module.exports = __webpack_public_path__ + "static/media/DSC08824-2.a4799a0f.jpeg";